






















































































import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true
    },
    newPhone: {
      type: String,
      required: true
    },
    oldPhone: {
      type: String,
      default: ""
    },
    userEmail: {
      type: String,
      default: ""
    }
  },
  
  data() {
    return {
      dialog: false,
      otpCode: "",
      otpDigits: ["", "", "", "", "", ""],
      loading: false,
      resending: false,
      error: "",
      successMessage: "",
      countdown: 60,
      countdownInterval: null as any
    };
  },
  
  computed: {
    formattedPhone(): string {
      if (!this.newPhone) return "";
      const phone = this.newPhone.toString();
      if (phone.length >= 7) {
        return phone.substring(0, 3) + "****" + phone.substring(phone.length - 3);
      }
      return phone;
    }
  },
  
  watch: {
    otpDigits: {
      deep: true,
      handler(val) {
        this.otpCode = val.join("");
      }
    },
    value(val) {
      this.dialog = val;
      if (val) {
        this.resetDialog();
        this.startCountdown();
      } else {
        this.stopCountdown();
      }
    },
    
    dialog(val) {
      this.$emit("input", val);
    }
  },
  
  beforeDestroy() {
    this.stopCountdown();
  },
  
  methods: {
    resetDialog() {
      this.otpCode = "";
      this.otpDigits = ["", "", "", "", "", ""];
      this.error = "";
      this.successMessage = "";
      this.countdown = 60;
    },
    
    onOtpInput(index: number, value: string) {
      if (value && value.match(/^[0-9]$/)) {
        if (index < 5) {
          this.$nextTick(() => {
            const nextInput = this.$refs[`otpInput${index + 1}`] as any;
            if (nextInput && nextInput[0]) {
              nextInput[0].focus();
            }
          });
        }
        
        if (this.otpDigits.filter(d => d !== "").length === 6) {
          this.verifyOtp();
        }
      } else if (value && !value.match(/^[0-9]$/)) {
        this.otpDigits[index] = "";
      }
    },
    
    onOtpKeydown(index: number, event: KeyboardEvent) {
      if (event.key === "Backspace" && !this.otpDigits[index] && index > 0) {
        event.preventDefault();
        const prevInput = this.$refs[`otpInput${index - 1}`] as any;
        if (prevInput && prevInput[0]) {
          this.otpDigits[index - 1] = "";
          prevInput[0].focus();
        }
      } else if (event.key === "ArrowLeft" && index > 0) {
        event.preventDefault();
        const prevInput = this.$refs[`otpInput${index - 1}`] as any;
        if (prevInput && prevInput[0]) {
          prevInput[0].focus();
        }
      } else if (event.key === "ArrowRight" && index < 5) {
        event.preventDefault();
        const nextInput = this.$refs[`otpInput${index + 1}`] as any;
        if (nextInput && nextInput[0]) {
          nextInput[0].focus();
        }
      } else if (event.key === "Enter") {
        event.preventDefault();
        if (this.otpCode.length === 6) {
          this.verifyOtp();
        }
      }
    },
    
    onOtpPaste(event: ClipboardEvent) {
      event.preventDefault();
      const pastedData = event.clipboardData?.getData("text") || "";
      const digits = pastedData.replace(/\D/g, "").split("").slice(0, 6);
      
      digits.forEach((digit, index) => {
        if (index < 6) {
          this.otpDigits[index] = digit;
        }
      });
      
      if (digits.length === 6) {
        this.$nextTick(() => {
          this.verifyOtp();
        });
      } else if (digits.length > 0) {
        const lastIndex = Math.min(digits.length, 5);
        const lastInput = this.$refs[`otpInput${lastIndex}`] as any;
        if (lastInput && lastInput[0]) {
          lastInput[0].focus();
        }
      }
    },
    
    startCountdown() {
      this.stopCountdown();
      this.countdown = 60;
      this.countdownInterval = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.stopCountdown();
        }
      }, 1000);
    },
    
    stopCountdown() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    },
    
    async verifyOtp() {
      if (this.otpCode.length !== 6) return;
      
      this.loading = true;
      this.error = "";
      
      try {
        const result = await coreApiClient.callRaw("auth", "verifyUpdatePhoneOtp", undefined, {
          newPhone: this.newPhone,
          otpCode: this.otpCode
        });
        
        if (result) {
          this.successMessage = "Phone number updated successfully!";
          setTimeout(() => {
            this.$emit("verified", result);
            this.close();
          }, 1500);
        }
      } catch (err) {
        this.error = (err as any).message || "Invalid OTP code. Please try again.";
        this.otpCode = "";
        this.otpDigits = ["", "", "", "", "", ""];
        const firstInput = this.$refs[`otpInput0`] as any;
        if (firstInput && firstInput[0]) {
          firstInput[0].focus();
        }
      } finally {
        this.loading = false;
      }
    },
    
    async resendOtp() {
      this.resending = true;
      this.error = "";
      
      try {
        await coreApiClient.callRaw("auth", "resendOtp", undefined, {
          phone: this.oldPhone,
          email: this.userEmail,
          phonePending: this.newPhone,
          type: "update_phone"
        });
        
        this.successMessage = "OTP has been resent successfully!";
        this.startCountdown();
        setTimeout(() => {
          this.successMessage = "";
        }, 3000);
      } catch (err) {
        this.error = (err as any).message || "Failed to resend OTP. Please try again.";
        this.startCountdown();
      } finally {
        this.resending = false;
      }
    },
    
    close() {
      if (!this.loading) {
        this.dialog = false;
        this.$emit("close");
      }
    }
  }
});
